import React from 'react';
import ReactJson from 'react-json-view';
import { CCMClientSettingsConfig } from '../../../config/CCMClientSettingsConfig';
import { ModalComponent } from '../../shared/modal-component/ModalComponent';

export const YamlSettingsViewModal = ({ title, isOpen, data, modalActions }) => {
  const { closeModal } = modalActions;
  const { REACT_JSON_THEME } = CCMClientSettingsConfig;

  return (
    <ModalComponent
      title={title}
      isOpen={isOpen}
      notifyOfClose={closeModal}
      customStyles={{ content: { maxHeight: '70%', marginTop: '5%' } }}
    >
      <ReactJson
        src={data}
        name={true}
        theme={REACT_JSON_THEME}
        enableClipboard={true}
        displayDataTypes={false}
        displayObjectSize={false}
        displayArrayKey={false}
        style={{ fontSize: '12px' }}
        indentWidth={4}
      />
    </ModalComponent>
  );
};
